<template>
  <div id="content">
    <create-card-form :user="user" v-if="user"></create-card-form> 
    <cards :user="user"></cards>
    <update-modal></update-modal>
    <stack-modal :user="user"></stack-modal>
  </div>
</template>

<script>
import Cards from '../cards/Index'
import CreateCardForm from '../cards/Create'
import UpdateModal from '../cards/UpdateModal'
import StackModal from '../cards/StackModal'

export default {
  props: ['user'],
  components: {
    Cards,
    CreateCardForm,
    UpdateModal,
    StackModal
  }
}
</script>


// WEBPACK FOOTER //
// Cards.vue?a93f6106